import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { PootsyButton } from './DesignFunctions'
import { PootsyTextArea } from './InputsFunctions'

import StarRaters from './StarRaters'
import ModalLayout from "./shared/ModalLayout"

class ReviewModal extends Component {
	state = {
		grade: 0,
		comment: ""
	}
	componentWillMount = () => {
		let { gradePrefill } = this.props
		if (gradePrefill) {
			this.setState({ grade: gradePrefill })
		}
	}
	handleStarClick = grade => {
		this.setState({ grade })
	}
	handleCommentChange = e => {
		this.setState({ comment: e.target.value })
	}
	handleSubmit = () => {
		this.props.sendReview({ ...this.state, booking: this.props.booking })
	}
	render(){
		let { t } = this.context
		let { toggleModal } = this.props
		let { grade, comment } = this.state
		return(
			<ModalLayout
				customClass="ReviewModal"
				contentClass="review-modal-content"
				title={t('review_modal_title')}
				closeModal={toggleModal}
				buttons={[
					<PootsyButton text={t("continue")} onClick={this.handleSubmit} key={0}/>,
					<PootsyButton text={t("cancel")} theme="cancel" onClick={toggleModal} key={1} />
				]}
			>
				<StarRaters value={grade} onChange={this.handleStarClick}/>
				<PootsyTextArea label={t("leave_a_message_optional")} value={comment} onChange={this.handleCommentChange}/>
			</ModalLayout>
		)
	}
}

ReviewModal.contextTypes = { t: PropTypes.func }
export default ReviewModal



// WEBPACK FOOTER //
// ./src/components/ReviewModal.js